export default __webpack_public_path__ + "static/media/playstore.961cd89c.png";